var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "study-FUN-item mb-16" },
    [
      _c("div", { staticClass: "block" }, [
        _c("div", { staticClass: "block-title" }, [
          _c("div", { staticClass: "dot" }),
          _vm._v(" " + _vm._s(_vm.item.title) + " "),
        ]),
      ]),
      _c("PDFView", { attrs: { url: _vm.item.pdf } }),
      _c(
        "div",
        { staticClass: "item-text" },
        [_c("content-renderer", { attrs: { content: _vm.item.content } })],
        1
      ),
      _c("div", { staticClass: "sub-block" }, [
        _c("div", { staticClass: "sub-title" }, [
          _vm._v(" " + _vm._s(_vm.$t("study.landing.download")) + " "),
        ]),
        _c("a", { attrs: { target: "_blank", href: _vm.item.pdf } }, [
          _vm._v(_vm._s(_vm.item.title) + ".pdf"),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }